import React, { createContext, useContext, useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

const AlertContext = createContext();

function SnackbarProvider  ({ children })  {
  // Instead of a single snackbar, we use an array for multiple notifications.
  const [snackbars, setSnackbars] = useState([]);

  /**
   * openSnackbar adds a new snackbar message to the array.
   * Each message gets a unique id.
   */
  const openSnackbar = useCallback((message, severity = 'info') => {
    const id = new Date().getTime(); // simple unique id; for more robust solutions, consider a uuid.
    setSnackbars((prev) => [...prev, { id, message, severity }]);
  }, []);

  /**
   * handleClose removes the snackbar with the specified id.
   */
  const handleClose = (id) => (event, reason) => {
    // Prevent closing if "clickaway" is the reason (optional)
    if (reason === 'clickaway') return;
    setSnackbars((prev) => prev.filter((snack) => snack.id !== id));
  };

  return (
    <AlertContext.Provider value={{ openSnackbar }}>
      {children}
      {snackbars.map((snack, index) => (
        <Snackbar
          key={snack.id}
          open
          autoHideDuration={3000}
          onClose={handleClose(snack.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{ mt: index * 8 }}
        >
          <Alert
            onClose={handleClose(snack.id)}
            severity={snack.severity}
            sx={{ width: '100%' }}
          >
            {snack.message}
          </Alert>
        </Snackbar>
      ))}
    </AlertContext.Provider>
  );
};
export default SnackbarProvider;
export const useSnackbar = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};
